import React from 'react'
import Menu from '../Menu/Menu'
import "./ProfileSide.css"

function ProfileSide() {
  return (
    <div className="ProfileSide">
        <Menu/>        
    </div>
  )
}

export default ProfileSide